import { jsx } from 'react/jsx-runtime';

const root = "_root_1he52_1";
const styles = {
	root: root
};

const ButtonGroup = ({ children, columnSize = "minmax(0, 1fr)", justify = "start", maxWidth = "initial" }) => {
  return jsx("div", { "data-zds": true, className: styles.root, style: {
    "--_zds-button-group-max-width": maxWidth,
    "--_zds-button-group-justify": justify,
    "--_zds-button-group-column-size": columnSize
  }, children });
};

export { ButtonGroup };
//# sourceMappingURL=ButtonGroup.es.js.map
